module.exports = __webpack_public_path__ + "static/media/hippopotamus.3d4e46db.svg";